import React from "react";

interface DraggableNodeProps {
  type: string;
  children: React.ReactElement<HTMLDivElement>;
}

export const DraggableTool: React.FC<DraggableNodeProps> = ({
  type,
  children,
}) => {
  const onDragStart = (event: any, nodeType: string) => {
    const appData = { nodeType };
    event.target.style.cursor = "grabbing";
    event.dataTransfer.setData(
      "application/reactflow",
      JSON.stringify(appData),
    );
    event.dataTransfer.effectAllowed = "move";
  };

  return React.cloneElement(children as any, {
    draggable: true,
    onDragStart: (e) => onDragStart(e, type),
    onDragEnd: (event: React.DragEvent<HTMLDivElement>) =>
      ((event.target as HTMLDivElement).style.cursor = "grab"),
  });
};
